import type { ButtonProps } from '@hover/blueprint';
import { Body, Box, transition } from '@hover/blueprint';
import React from 'react';

import { Button, CustomIcon } from 'src/shared/components';

import { TOOLBAR_BUTTON_SIDE_LENGTH } from './toolBarConstants';

const activeColor = 'neutral.700';
const inActiveColor = 'neutral.600';
const disabledColor = 'neutral.400';

interface ToolbarButtonProps extends Pick<ButtonProps, 'onClick'> {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  text: string;
  active: boolean;
  disabled?: boolean;
}

const ToolbarButton = ({
  onClick,
  text,
  icon,
  active,
  disabled,
}: ToolbarButtonProps) => {
  let color = inActiveColor;
  if (disabled) {
    color = disabledColor;
  } else if (active) {
    color = activeColor;
  }
  return (
    <Button
      alignSelf="center"
      fill="minimal"
      height={`${TOOLBAR_BUTTON_SIDE_LENGTH}px`}
      label={text}
      marginTop={100}
      onClick={onClick}
      shape="square"
      width={`${TOOLBAR_BUTTON_SIDE_LENGTH}px`}
    >
      <Box
        alignItems="center"
        flex={1}
        flexDirection="column"
        justifyContent="center"
      >
        <CustomIcon
          color={color}
          icon={icon}
          {...transition.easing250('color')}
        />
        <Body color={color} margin={0} size={300}>
          {text}
        </Body>
        <Box
          backgroundColor="primary.base"
          height="2px"
          marginTop="100"
          {...transition.easing250('width', 'opacity')}
          opacity={active ? 1 : 0}
          width={active ? '20px' : '0px'}
        />
      </Box>
    </Button>
  );
};

export { ToolbarButton };
